import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector, reset } from 'redux-form';
import {Grid, Row, Col} from 'react-bootstrap'
import DateTimeField from '../common/DateTimeField'
import DragAndDrop from '../common/DndGallery.jsx'
import PrintView from './PrintView'
import Load from '../Load'
import _ from 'lodash'
import moment from 'moment-timezone'
import {uploadDocument, unplannedTestsStatus, didPrintTest} from '../../actions/index'
import {timezone, aircraftIsTurboProp, fourEngines} from '../../constants'
import {
    //formatInt,
    renderTextField,
    renderErrorField,
    renderAircraftSelector,
    renderOperatorSelector,
    renderHeadingSelector,
    renderLocationSelector,
    renderSecondsAsMinutesSelector,
    renderNumbersExtendedSelector,
    renderOneToFour
} from '../common/RenderFields'
import ReactDOM from 'react-dom'

let preventDoubleSubmitTimer = undefined

let clearPreventDoubleSubmitTimer = () => {
    if (preventDoubleSubmitTimer) {
        window.clearTimeout(preventDoubleSubmitTimer)
    }
    preventDoubleSubmitTimer = undefined
}

class CreateTestForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            didTouch: {},
            didGetUnplannedTestsStatus: false,
            didLoadPrintDiv: false
        }
    }

    isNight = (props) => {
        if (!props.startedAt) {return false}
        const startHours = props.startedAt.tz(timezone).hours()
        const endHours = props.duration ? moment(props.startedAt).add({seconds: props.duration}).tz(timezone).hours() : startHours
        return startHours < 7 || startHours >= 22 || endHours < 7 || endHours >= 22
    }

    onDrop = (f) => {
        //console.log('onDrop', f)
        this.props.dispatch(uploadDocument(f))
    }

    componentWillUpdate(nextProps) {

        if (!this.state.didGetUnplannedTestsStatus &&
            (_.some([1,2,3,4].map(i => nextProps[`e${i}High`]))) &&
            this.isNight(nextProps) &&
            nextProps.aircraft && !aircraftIsTurboProp(nextProps.aircraft)) {
            this.props.dispatch(unplannedTestsStatus())
            this.setState({didGetUnplannedTestsStatus: true})
        }

        if (nextProps.completing && !this.state.didTouch.testerName) {
            console.log('touch field', 'testerName')
            this.props.touch('testerName')
            this.setState({didTouch: _.set(this.state.didTouch, 'testerName', true)})
        }

        //console.log('componentWillUpdate', nextProps)
        _.forEach([
            'startedAt',
            'firstEngineOn',
            'lastEngineOff',
            'scheduledDeparture'
        ], k => {
            if (!this.state.didTouch[`${k}Day`]) {
                this.props.touch(`${k}Day`)
                this.setState({didTouch: _.set(this.state.didTouch, `${k}Day`, true)})
            }

            if (nextProps[k] && !this.state.didTouch[k]) {
                console.log('touch field', k)
                this.props.touch(k)
                this.props.touch(`${k}Day`)
                this.props.touch(`${k}Hours`)
                this.props.touch(`${k}Minutes`)
                this.props.touch(`${k}Error`)
                this.setState({didTouch: _.set(this.state.didTouch, k, true)})
            }
        })

        _.forEach(['duration'], k => {
            if (nextProps[k] && !this.state.didTouch[k]) {
                console.log('touch field', k)
                this.props.touch(k)
                this.setState({didTouch: _.set(this.state.didTouch, k, true)})
            }
        })

        _.forEach([1,2,3,4], i => {
            if (this.state.didTouch[`e${i}Error`]) {return}
            let engineTime = 0;
            [`Idle`, `Med`, `High`].forEach(s => {
                if (typeof this.props[`e${i}${s}`] === 'string') {
                    engineTime = parseInt(this.props[`e${i}${s}`], 10) || 0
                } else {
                    engineTime = this.props[`e${i}${s}`] || 0
                }
            })

            if (engineTime) {
                this.props.touch(`e${i}Error`)
                this.setState({didTouch: _.set(this.state.didTouch, `e${i}Error`, true)})
            }
        })
    }

    render() {
        const { handleSubmit, change } = this.props;

        //console.log('CreateTestForm', this.props)
        //console.log('CreateTestForm group',(this.props.group || {}).name, this.props.group)

        let approvalDocLastComponent = undefined
        if (this.props.approvalDoc) {
            const components = this.props.approvalDoc.split('/')
            if (components && components.length > 0) {
                approvalDocLastComponent = components[components.length - 1]
            }
        }

        return (
            <form className="my-form" ref="form" onSubmit={handleSubmit}>

                <div className="timezone-title">Enter all times in local time zone</div>

                <div className="my-section">
                    <Grid fluid>
                        <Row>
                            <Col xs={12} sm={6}>
                                <DateTimeField
                                    name={'startedAt'}
                                    label={'Date and Time of Test (Local time)'}
                                    val={this.props.initialValues.startedAt}
                                    myOnChange={event => {
                                    if (!this.props.firstEngineOn) {
                                        //console.log('setting firstEngineOn', event, moment(event).tz(timezone))
                                        const m = moment(event).tz(timezone)
                                        change('firstEngineOn', m)
                                        change('firstEngineOnDay', m.format('YYYY-MM-DD'))
                                        change('firstEngineOnHours', m.format('HH'))
                                        change('firstEngineOnMinutes',  m.format('mm'))
                                    }
                                }}/>
                                <Field name="startedAtError" component={renderErrorField}/>
                            </Col>
                            <Col sm={1} xsHidden> </Col>
                            <Col xs={12} sm={5}>
                                <Field name="maintenanceAgency" label="Maintenance Agency" component={renderTextField} disabled={true} ignoreTouched={true} />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} sm={6}>
                                <Field name="operator" label="Aircraft Operator" component={renderOperatorSelector}/>
                            </Col>
                            <Col sm={1} xsHidden> </Col>
                            <Col xs={12} sm={5}>
                                {this.props.operator === 'Other' && <Field name="otherOperator" label="Other Operator" component={renderTextField} />}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} sm={12} >
                                <Field name="schedulerName" label="Scheduler name" component={renderTextField} />
                            </Col>
                            <Col xs={12} sm={12} >
                                <Field name="testerName" label="Tester name" component={renderTextField} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6} >
                                <Field name="aircraft" label="A/C Type" component={renderAircraftSelector}/>
                            </Col>
                            <Col sm={1} xsHidden> </Col>
                            <Col xs={12} sm={5}>
                                {this.props.aircraft === 'Other' && <div>
                                    <div className="note">Note: Unknown aircraft cannot be included in acoustic calculation</div>
                                    <Field name="otherAircraft" label="Specify Other Aircraft Type" component={renderTextField} />
                                </div>}

                            </Col>

                            <Col xs={12} style={{marginTop: '10px'}}>
                                <Field name="aircraftRegistration" label="A/C Registration" component={renderTextField} />
                            </Col>

                            <Col xs={12}>
                                <div className="note">
                                    Note: Unplanned engine tests only apply to jet engine tests carried out at high
                                    power between the hours 2200 and 0700, which do not have Signoff.
                                    Only 5 such tests can occur in any 3 month period.
                                </div>
                                {this.props.unplannedTestsStatus && <div>
                                    {`There have been ${this.props.unplannedTestsStatus.last3Months || 0} unplanned tests in the last 3 months, and ${this.props.unplannedTestsStatus.currentYear || 0} in the current calendar year`}
                                </div>}
                            </Col>

                            <Col xs={12}>
                                <Field name="reason" label="Reason for Test" component={renderTextField} />
                            </Col>

                        </Row>

                        <Row>
                            <Col xs={12} sm={3}>
                                <label><Field name="antarctic" component="input" type="checkbox"/><div className="exclusions-text">Tick this box if this aircraft is being used for Antarctic Operations</div></label>
                            </Col>
                            <Col xs={12} sm={3}>
                                <label><Field name="approved" component="input" type="checkbox"/><div className="exclusions-text">Tick this box if there is Director CAA or Minister of Transport signoff</div></label>
                            </Col>
                            <Col xs={12} sm={3}>
                                <label><Field name="naturalDisaster" component="input" type="checkbox"/><div className="exclusions-text">Tick this box if the test is carried out due to an aircraft fleet safety issue, or as a result of a natural disaster</div></label>
                            </Col>

                            <Col xs={12} sm={3}>
                                <label><Field name="runway11InUse" component="input" type="checkbox"/><div className="exclusions-text">Tick this box if Runway 11/29 is in use</div></label>
                            </Col>

                            {this.props.approved && <Col xs={12} >
                                <label htmlFor="approvalDoc">Upload approval document</label>
                                {approvalDocLastComponent && <div>Uploaded approval document: <a href={this.props.approvalDoc}>{approvalDocLastComponent}</a></div>}
                                <DragAndDrop onDrop={this.onDrop} />
                                {!this.props.approvalDoc && <Field name="approvalDocError" ignoreTouched={true} component={renderErrorField}/>}
                            </Col>}
                        </Row>

                        {!this.props.approved && <Row>
                            <Col xs={12}>
                                <label>Type of Test:</label>
                            </Col>

                            <Col xs={12}>
                                <label><Field name="duty" component="input" type="radio" value="light"/>Light/Line maintenance</label>
                            </Col>
                            <Col xs={12}>
                                <label><Field name="duty" component="input" type="radio" value="heavy"/>Heavy maintenance</label>
                            </Col>

                            {this.isNight(this.props) &&
                                this.props.aircraft &&
                                !aircraftIsTurboProp(this.props.aircraft) &&
                                !this.props.antarctic &&
                                !this.props.naturalDisaster &&
                                !this.props.approved && <Col xs={12}>
                                <label>{/*<Field
                                    name="unplanned"
                                    component="input"
                                    type="checkbox"
                                    value="unplanned"
                                    disabled={true}
                                    onChange={event => {
                                        //get counts of current unplanned tests
                                        //console.log('unplanned onchange', event, event.target)
                                        if (!this.props.unplannedTestsStatus && event.target.value) {
                                            this.props.dispatch(unplannedTestsStatus())
                                        }
                                    }}*/}



                                    <input
                                        name="unplanned"
                                        type="checkbox"
                                        disabled
                                        checked={_.some([1,2,3,4].map(i => this.props[`e${i}High`]))} //0 == false
                                        onChange={_ => {}}
                                    />
                                    Unplanned Engine Test</label>
                            </Col>}
                        </Row>}

                        <Row>
                            <Col xs={12}>
                                <Field name="weather" label="Weather conditions" component={renderTextField} />
                            </Col>

                            <Col xs={12}>
                                <Field name="location" label="Test location" component={renderLocationSelector}/>
                            </Col>

                            <Col xs={12}>
                                <Field name="heading" label="A/C heading" component={renderHeadingSelector}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={3} style={{marginTop: '16px'}}>
                                <Field
                                    name="duration"
                                    label="Duration of test (mins)"
                                    firstEntry="Minutes..."
                                    component={renderSecondsAsMinutesSelector}
                                    onChange={event => {
                                        if (this.props.startedAt && ((event || {}).target || {}).value && !this.props.lastEngineOff) {
                                            try {
                                                const seconds = parseInt(event.target.value, 10) //60 * Math.floor(parseInt(event.target.value, 10) / 60)
                                                const m = moment(this.props.startedAt).add({seconds: seconds}).tz(timezone)
                                                change('lastEngineOff', m)
                                                change('lastEngineOffDay', m.format('YYYY-MM-DD'))
                                                change('lastEngineOffHours', m.format('HH'))
                                                change('lastEngineOffMinutes',  m.format('mm'))
                                            } catch (e) {}
                                        }
                                }}/>
                            </Col>
                        </Row>

                        {[1,2].map(i => <Row key={`eng${i}`}>
                            <Col xs={3}>{`#${i} Engine run time (mins):`}</Col>
                            {['Idle','Med','High'].map(p => <Col key={`eng${i}${p}`} xs={3}><Field name={`e${i}${p}`} label={p} component={renderNumbersExtendedSelector}/></Col>)}
                            <Col xs={12}><Field name={`e${i}Error`} component={renderErrorField}/></Col>
                        </Row>)}

                        {fourEngines(this.props.aircraft) && <div>
                            {[3,4].map(i => <Row key={`eng${i}`}>
                                <Col xs={3}>{`#${i} Engine run time (mins):`}</Col>
                                {['Idle','Med','High'].map(p => <Col key={`eng${i}${p}`} xs={3}><Field name={`e${i}${p}`} label={p} component={renderNumbersExtendedSelector}/></Col>)}
                                <Col xs={12}><Field name={`e${i}Error`} component={renderErrorField}/></Col>
                            </Row>)}
                        </div>}

                        <Row>
                            <Col xs={12} sm={6}>
                                <Field name="maxSimultaneousHighPower" label="Max. simultaneous engines at high power" component={renderOneToFour}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} sm={6}>
                                <DateTimeField name={'firstEngineOn'} label={'First engine on at test location'} val={this.props.initialValues.firstEngineOn}/>
                                <Field name="firstEngineOnError" component={renderErrorField}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={6}>
                                <DateTimeField name={'lastEngineOff'} label={'Last engine off'} val={this.props.initialValues.lastEngineOff}/>
                                <Field name="lastEngineOffError" component={renderErrorField}/>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} sm={6}>
                                <DateTimeField
                                    name={'scheduledDeparture'}
                                    label={'Aircraft Scheduled Departure Date and Time'}
                                    val={this.props.initialValues.scheduledDeparture}
                                    wideDateRange/>
                                <Field name="scheduledDepartureError" component={renderErrorField}/>
                            </Col>
                        </Row>

                    </Grid>

                </div>


                {/*console.log('refs', this.refs, this.props)*/}

                <div className="my-section" style={{borderBottom: 'dashed 0px #ccc'}}>
                    {this.props.unplannedInitiallyRejected
                        ? <div>
                            <div>If you are unable to reschedule the test or change the parameters so as to avoid exceeding noise limits, you can confirm these test details</div>
                            <button className="submit" type="submit" style={{backgroundColor: 'red'}}>Confirm test details</button>
                        </div>
                        : <button className="submit" type="button" disabled={preventDoubleSubmitTimer} onClick={() => {
                            if (preventDoubleSubmitTimer) {return}
                            preventDoubleSubmitTimer = window.setTimeout(clearPreventDoubleSubmitTimer, 3*1000)
                            this.props.submit()
                        }}>Save test details</button>}
                    <button className="link" type="button" onClick={() => this.props.dispatch(reset('CreateTestForm'))}>Reset form</button>
                    <button className="link" type="button" onClick={this.props.close}>Cancel</button>
                    <button className="link" type="button" onClick={this.printForm}>Print</button>
                    {this.props.didPrint && <div>Test has been printed</div>}

                    {((this.props.loading || {}).createTest || (this.props.loading || {}).updateTest) && <Load/>}

                    {(this.props.dataError || {}).createTest && <div className="create-test-error">
                        {`Error on creating test: ${(this.props.dataError || {}).createTest}`}
                    </div>}
                    {(this.props.dataError || {}).updateTest && <div className="create-test-error">
                        {`Error on updating test: ${(this.props.dataError || {}).updateTest}`}
                    </div>}

                </div>

            </form>
        );
    }

    printForm = () => {
        if (!document.getElementById('print-mount')) {return}
        ReactDOM.render(<PrintView {...this.props} />, document.getElementById('print-mount'), () => {
            window.print()
            if (this.props.testId && !this.props.didPrint) {
                this.props.dispatch(didPrintTest(this.props.testId))
            }
        });
    }
}

const validate = (values, props) => {
    const errors = {}

    //return {} //testing

    //console.log('create test form validate', values, 'props', props)

    if (values.approved && !values.approvalDoc) {
        errors.approvalDocError = 'Approval document required'
    }

    _.forEach([
        //'maintenanceAgency',
        'operator',
        'aircraft',
        'aircraftRegistration',
        'reason',
        'weather',
        'location',
        "heading",
        "duration",
        "schedulerName"
    ], k => {
        if (!values[k]) {
           errors[k] = 'Required'
        }
    })

    if (props.completing && !values.testerName) {
        errors.testerName = 'Required'
    }

    //if (!values.maintenanceAgency) {}

    if (values.aircraft === 'Other' && !values.otherAircraft) {
        errors.otherAircraft = 'Required'
    }

    if (values.operator === 'Other' && !values.otherOperator) {
        errors.otherOperator = 'Required'
    }

    _.forEach([
        'startedAt',
        'firstEngineOn',
        'lastEngineOff',
        'scheduledDeparture'
    ], k => {
        if (!values[k]) {
            errors[`${k}Error`] = 'Required'
        }

        if (!values[k] instanceof moment) {
            errors[`${k}Error`] = 'Needs completion'
        }
    })

    _.forEach([
        'firstEngineOn',
        'lastEngineOff'
    ], k => {
        if (values.startedAt && values[k] && values[k].isBefore(values.startedAt)) {
            //console.log('iiii', values.startedAt, values[k], values[k].isBefore(values.startedAt))
            errors[`${k}Error`] = `Must be after test start time: ${values.startedAt.format('DD/MM HH:mm')}`
        }
    })

    if (values.firstEngineOn && values.lastEngineOff && values.lastEngineOff.isBefore(values.firstEngineOn)) {
        errors.lastEngineOffError = `Must be after first engine on time: ${values.firstEngineOn.format('DD/MM HH:mm')}`
    }

    const engineTimes = {};
    _.forEach([1,2,3,4], i => {
        engineTimes[`e${i}`] = 0;
        [`Idle`, `Med`, `High`].forEach(s => {
            if (typeof values[`e${i}${s}`] === 'string') {
                values[`e${i}${s}`] = parseInt(values[`e${i}${s}`], 10) || 0
            } else {
                values[`e${i}${s}`] = values[`e${i}${s}`] || 0
            }
            engineTimes[`e${i}`] += values[`e${i}${s}`]
        })
    })
    if ((engineTimes.e1 + engineTimes.e2) === 0) {

        if (fourEngines(values.aircraft)) {
            if ((engineTimes.e3 + engineTimes.e4) === 0) {
                [1,2,3,4].forEach(i => errors[`e${i}Error`] = 'Required')
            }
        } else {
            [1,2].forEach(i => errors[`e${i}Error`] = 'Required')
        }
    }
    const notFalse = (x) => {
        return x || x === 0
    };
    [1,2,3,4].forEach(i => {
        if (notFalse(values.duration) && values.duration < engineTimes[`e${i}`]) {
            errors.duration = `Duration is shorter than engine ${i} run time`
        }
    })

    if (!errors.lastEngineOffError && values.firstEngineOn && values.lastEngineOff) {
        const duration = moment.duration(values.lastEngineOff.diff(values.firstEngineOn));
        const seconds = duration.asSeconds();

        [1,2,3,4].forEach(i => {
            if (notFalse(engineTimes[`e${i}`]) && seconds < engineTimes[`e${i}`]) {
                errors.lastEngineOffError = `Difference between last engine off and first engine on is shorter than engine ${i} run time`
            }
        })
    }

    if (values.startedAt && values.duration) {
        const endedAt = moment(values.startedAt).add({seconds: values.duration}).tz(timezone)
        //console.log('started', values.startedAt.format(), 'endedAt', endedAt.format(), 'secs', values.duration)

        _.forEach([
            'firstEngineOn',
            'lastEngineOff'
        ], k => {
            //console.log(k, values[k].format(), 'endedAt', endedAt.format(), values[k].isAfter(endedAt))
            if (values[k] && values[k].isAfter(endedAt)) {
                errors[`${k}Error`] = `Must be before test end time: ${endedAt.format('DD/MM HH:mm')}`
            }
        });

        [1,2,3,4].forEach(i => {
            const engineEnded = moment(values.startedAt).add({seconds: engineTimes[`e${i}`]}).tz(timezone)
            //console.log('vv', values.lastEngineOff, values.lastEngineOff.isBefore(e1EndedAt), values.lastEngineOff.isBefore(e2EndedAt))
            if (values.lastEngineOff && values.lastEngineOff.isBefore(engineEnded)) {
                errors[`lastEngineOffError`] = `Must be after end of engine ${i} run time: ${engineEnded.format('DD/MM HH:mm')}`
            }
        })
    }

    //console.log('errors', errors)
    return errors
}

const selector = formValueSelector('CreateTestForm')
CreateTestForm = reduxForm({
    form: 'CreateTestForm',
    //touchOnChange: true,
    //pure: false,
    validate
})(CreateTestForm);

CreateTestForm = connect((state,props) => {

    //console.log('CreateTestForm connect', props)

    const engines = [];
    [1,2,3,4].forEach(i => {
        ['Idle', 'Med', 'High'].forEach(p => {
            engines.push(`e${i}${p}`)
        })
    });

    const fields = [
        'aircraft',
        'location',
        'heading',
        'startedAt',
        'duration',
        'antarctic',
        'naturalDisaster',
        'approved',
        ...engines,
        'operator',
        'otherOperator',
        'otherAircraft',
        'aircraftRegistration',
        'reason',
        'weather',
        'scheduledDeparture',
        'firstEngineOn',
        'lastEngineOff',
        'lightMaintenance',
        'heavyMaintenance',
        'unplanned',
        'runway11InUse',
        'testerName',
        'schedulerName',
        'didPrint',
        'status',
        'maxSimultaneousHighPower',
    ]

    const selectors = {}
    fields.forEach(k => {
        selectors[k] = selector(state, k)
    })

    // const operator = selector(state, 'operator')
    // const aircraft = selector(state, 'aircraft')
    // const antarctic = selector(state, 'antarctic')
    // const approved = selector(state, 'approved')
    // const startedAt = selector(state, 'startedAt')
    // const firstEngineOn = selector(state, 'firstEngineOn')
    // const lastEngineOff = selector(state, 'lastEngineOff')
    // const duration = selector(state, 'duration')
    // const e1High = selector(state, 'e1High')
    // const e2High = selector(state, 'e2High')


    const startsWith = (str, searchString, position) => {
        position = position || 0;
        return str.substr(position, searchString.length) === searchString;
    };

    let test = props.editingTest || {}
    //remove 'planned' fields
    _.keys(test).forEach(k => {
        if (startsWith(k, 'planned')) {
            test = _.omit(test, k)
        }
    })

    const createDateFields = (k, m) => {
        //console.log('createDateFields', k, m instanceof moment, m.format('DD/MM'))
        if (!(k && (m instanceof moment))) {
            console.log('createDateFields called with invalid params', k, m)
            return
        }

        if (!m.isValid()) {
            console.log('createDateFields m invalid')
            return
        }

        try {
            test[`${k}Day`] = m.format('YYYY-MM-DD')
            test[`${k}Hours`] = m.format('HH')
            test[`${k}Minutes`] = m.format('mm')
        } catch (e) {
            console.log('createDateFields', e, k, m)
        }
    }

    _.forEach(['startedAt','scheduledDeparture','firstEngineOn','lastEngineOff'], k => {
        if (test[k] && typeof test[k] === 'string') {
            //create moment objects from date strings
            //console.log('moment from str', test[k])
            const m = moment(test[k], 'YYYY-MM-DDTHH:mm:ssZ').tz(timezone)
            if (m.isValid()) {
                test[k] = m
                createDateFields(k, test[k])
            }
        } else if (!test[`${k}Day`]) {
            //set the day field, as it looks a bit odd when the current day is selected in the dropdown, but not in the data
            //test[`${k}Day`] = moment().tz(timezone).format('YYYY-MM-DD')
            //console.log('did set day', `${k}Day` , test[`${k}Day`])
        }
    })

    if (test.duration) {
        test.duration = Math.ceil(test.duration / 60) * 60 //round up to minutes
    }

    //test.durationMins = test.duration ? Math.round(test.duration / 60 / 1000) : undefined
    test.duty = test.lightMaintenance ? 'light' : test.heavyMaintenance ? 'heavy' : undefined

    //console.log('connect approvalDoc', props.uploadUrl)

    const initialValues = {
        maintenanceAgency: (props.testGroup || {}).name || (props.group || {}).name,
        //ownerUsername: (props.user || {}).name, //CIAL have requested to not pre-populate this field
        approvalDoc: props.uploadUrl,

        //editing previous
        ...test
    }

    //console.log('existingFields', initialValues)

    selectors.initialValues = initialValues
    selectors.maintenanceAgency = initialValues.maintenanceAgency
    selectors.testId = test.id
    selectors.didPrint = test.didPrint
    selectors.approvalDoc = props.uploadUrl
    selectors.reference = test.reference

    //console.log('selectors', selectors)

    return selectors
})(CreateTestForm)

export default CreateTestForm



// WEBPACK FOOTER //
// ./src/components/tests/CreateTestForm.jsx